import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'

import NanumSquareNeoBold from '~/shared/fonts/NanumSquareNeoBold.ttf'
import NanumSquareNeoExtraBold from '~/shared/fonts/NanumSquareNeoExtraBold.ttf'
import NanumSquareNeoHeavy from '~/shared/fonts/NanumSquareNeoHeavy.ttf'
import NanumSquareNeoLight from '~/shared/fonts/NanumSquareNeoLight.ttf'
import NanumSquareNeoRegular from '~/shared/fonts/NanumSquareNeoRegular.ttf'
import theme from '~/shared/styles/theme'

export const GlobalStyle = createGlobalStyle`
  ${reset};
  box-sizing: border-box;
  appearance: none;

  @font-face {
    font-family: NanumSquareNeo-Light;
    font-weight: 400;
    font-style: normal;
    src: url(${NanumSquareNeoLight}) format('truetype');
  }

  @font-face {
    font-family: NanumSquareNeo-Regular;
    font-weight: 500;
    font-style: normal;
    src: url(${NanumSquareNeoRegular}) format('truetype');
  }

  @font-face {
    font-family: NanumSquareNeo-Bold;
    font-weight: 700;
    font-style: normal;
    src: url(${NanumSquareNeoBold}) format('truetype');
  }

  @font-face {
    font-family: NanumSquareNeo-ExtraBold;
    font-weight: 800;
    font-style: normal;
    src: url(${NanumSquareNeoExtraBold}) format('truetype');
  }

  @font-face {
    font-family: NanumSquareNeo-Heavy;
    font-weight: 900;
    font-style: normal;
    src: url(${NanumSquareNeoHeavy}) format('truetype');
  }

  html, body {
    overflow-x: hidden;

    font-family: NanumSquareNeo-Regular, sans-serif;
    color: #000;
    text-size-adjust: none;

    -ms-overflow-style: none;

  }

  ::-webkit-scrollbar {
    display: none;
  
  }

  * {
    font-family: NanumSquareNeo-Regular, sans-serif;

    }

    input::placeholder {
      font-size: 12px;
      font-style: italic;
      color: ${theme.colors.grey_3}
    }

  circle,
  rect,
  line {
    fill: transparent;
    stroke-linecap: round;
    stroke-width: 10px;
  }
`
